import React, { useState, useEffect } from "react";
import classes from "./PendingInvoices.module.css";
import { useTranslation } from "react-i18next";

import {
  Seo,
  Avatar,
  InvoiceCardBanner,
  CircleSpinner,
  EmptyProductsMsg,
} from "@components";

/** Redux **/
import { fetchPendingInvoices } from "@store/pendingInvoices";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "reactstrap";

/** Third Party **/
import { Config } from "@config/config";
import { NavLink, useNavigate, Navigate, useLocation } from "react-router-dom";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export const PendingInvoices = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { data, loading } = useSelector(
    (state) => state.pendingInvoices.pendingInvoices
  );

  useEffect(() => {
    dispatch(fetchPendingInvoices());
  }, [dispatch]);

  const [status, setStatus] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    setStatus(value);
    dispatch(fetchPendingInvoices({ paid: value }));
  };

  return (
    <>
      <Seo title={`${Config.name} | ${t("pendingInvoices")}`} />
      <div className={`${classes.block}`}>
        <div className={`container`}>
          <div
            className={`${classes.mainTitle} d-flex align-items-center justify-content-between`}>
            {!status
              ? t("invoices")
              : status === "paid"
              ? t("paidInvoices")
              : t("pendingInvoices")}
            <FormControl sx={{ m: 0, minWidth: 100 }}>
              <Select
                value={status}
                onChange={handleChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}>
                <MenuItem value="">{t("Status.all")}</MenuItem>
                <MenuItem value={"paid"}>{t("Status.paid")}</MenuItem>
                <MenuItem value={"pending"}>{t("Status.pending")}</MenuItem>
                {/* <MenuItem value={"returned"}>{t("Status.returned")}</MenuItem> */}
                {/* <MenuItem value={"failed"}>{t("Status.failed")}</MenuItem> */}
              </Select>
            </FormControl>
          </div>

          {/* {loading ? (
            <CircleSpinner className={"pt-4"} size="lg" />
          ) : data?.length > 0 ? (
            <div className={`${classes.grid}`}>
              {data?.length > 0
                ? data?.map((row) => {
                    return <InvoiceCardBanner status={status} row={row} />;
                  })
                : ""}
            </div>
          ) : (
            <Alert color="danger">
              {status
                ? t("noData", { status: t(`Status.${status}`) })
                : t("noDataYet")}
            </Alert>
          )} */}

          {loading ? (
            <CircleSpinner className={"pt-4"} size="lg" />
          ) : data?.length > 0 ? (
            <div className={`${classes.grid}`}>
              {data?.length > 0
                ? data?.map((row) => {
                    return <InvoiceCardBanner status={status} row={row} />;
                  })
                : ""}
            </div>
          ) : (
            <Alert color="danger">
              {status
                ? t("noData", { status: t(`Status.${status}`) })
                : t("noDataYet")}
            </Alert>
            // <EmptyProductsMsg
            //   text={t("noData", { status: t(`Status.${status}`) })}
            // />
          )}
        </div>
      </div>
    </>
  );
};
